import React, { Component } from 'react';
import axios from "axios";
import VForm from 'react-validation/build/form';
import VInput from 'react-validation/build/input';
import VButton from 'react-validation/build/button';
import validator from 'validator';
import Waiting from '../../../waiting';
import { appConfig } from '../../../../tools/AppConfig';
import jazzCashLogo from "./../../../../../statics/img/jazzcash/jazzcash.png";
import paymobLogo from "./../../../../../statics/img/esaypaisa/paymob.png";
import JazzCashStatus from './JazzCashStatus';
import Countdown360 from 'react-countdown360';
import {decode as base64_decode, encode as base64_encode} from 'base-64';
import jwt_decode from "jwt-decode";
import './JazzCash.css';

const required = (value) => {
    if (!value.toString().trim().length) {
      // We can return string or jsx as the 'error' prop for the validated Component
      return <div className="alert alert-danger fieldErrorMessage" role="alert"> This field is required.</div>;
    }
};
const phoneV = (value) => {
    if(!validator.isNumeric(value) || value.length != 11 || value.toString()[0] != 0 || value.toString()[1] != 3){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"> Please enter a valid phone number.</div>;
    }
};
const cnicV = (value) => {
    if(!validator.isNumeric(value) || value.length != 6){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"> Please enter last 6 digits of cnic.</div>;
    }
};

class JazzCash extends Component {

    constructor(props) {
        super(props)
        this.state = {
            step: 1,
            phone: "",
            cnic: "",
            user_data: "",
            trnx_id: "",
            count_down: true,
            jazzcash_status: "",
            status_message: "",
            redirection_url: "",
            re_inquire_times: 0,
            //public
            waiting: false,
            error: false,
            error_message: "",
        }
    }
    componentDidMount() {
        this.decodePaymentToken()
    }
    
    // decode payment token
    decodePaymentToken = () => {
        // decode from base64 format
        let base64 = base64_decode(this.props.payment_token);
        // decode from jwt format
        let jwt = jwt_decode(base64);
        this.setState({user_data: jwt});
    }
    // pay request
    handlePayRequest = (e) =>{
        this.setState({waiting: true}, ()=>{
            let url = appConfig.getServerUrl() + '/api/acceptance/payments/pay';
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            let data = {
                "source": {
                    "identifier": "jazzcash",
                    "mobile_number": this.state.phone,
                    "national_id": this.state.cnic,
                    "subtype": "JAZZCASH"
                },
                "payment_token": this.props.payment_token
            }
            let jsonData = JSON.stringify(data);
            axios.post(
                url,
                jsonData,
                config
            )
            .then((resp)=>{
                this.setState({waiting: false, error: false, error_message: "", step: 2, trnx_id: resp.data.id});
            })
            .catch((err)=>{
                if(err.response){
                    if(err.response.status == 401){
                        this.setState({waiting: false, error: true, error_message: err.response.data.detail});
                    }else{
                        if(err.response.data.message){
                            this.setState({waiting: false, error: true, error_message: err.response.data.message});
                        }else{
                            this.setState({waiting: false, error: true, error_message: "Something went wrong. please try again later."});
                        }
                    }  
                }else{
                    this.setState({waiting: false, error: true, error_message: "Something went wrong. please try again later."});
                }
            });
        });
        e.preventDefault();
    }
    // inquiry request
    handleInquiryRequest = () =>{
        this.setState({waiting: true}, ()=>{
            let url = appConfig.getServerUrl() + '/api/acceptance/jazzcash/status_inquiry?transaction_id=' + this.state.trnx_id;
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            axios.get(
                url,
                config
            )
            .then((resp)=>{
                // success
                if(resp.data.success == true && resp.data.pending == false){
                    this.setState({waiting: false, step: 3, jazzcash_status: "success", status_message: resp.data.message, redirection_url: resp.data.redirection_url});
                // pending
                }else if(resp.data.success == false && resp.data.pending == true){
                    // Max Reinquire Times (3)
                    this.setState({re_inquire_times: this.state.re_inquire_times + 1});
                    if(this.state.re_inquire_times == 3){
                        this.setState({waiting: false, step: 3, jazzcash_status: "pending", status_message: resp.data.message, redirection_url: resp.data.redirection_url});
                    }else{
                        this.setState({waiting: false, count_down: true});
                    }
                // fail
                }else if(resp.data.success == false && resp.data.pending == false){
                    this.setState({waiting: false, step: 3, jazzcash_status: "fail", status_message: resp.data.message, redirection_url: resp.data.redirection_url});
                }
            })
            .catch((err)=>{
                if(err.response){
                    if(err.response.status == 401){
                        this.setState({waiting: false, count_down: false, error: true, error_message: err.response.data.detail});
                    }else{
                        if(err.response.data.message){
                            this.setState({waiting: false, count_down: false, error: true, error_message: err.response.data.message});
                        }else{
                            this.setState({waiting: false, count_down: false, error: true, error_message: "Something went wrong. please try again later."});
                        }
                    }  
                }else{
                    this.setState({waiting: false, count_down: false, error: true, error_message: "Something went wrong. please try again later."});
                }
            });
        });
    }
    // handle return back
    handleReturnBack = () => {
        this.setState({step: 3, jazzcash_status: "fail", status_message: "Transaction abandoned."});
    }
    renderStep1 = () => (
        <div className="jazzcash_content">
            <VForm onSubmit={this.handlePayRequest}>
                <label>Phone number</label>
                <VInput 
                    type="text"
                    name="phone"
                    value={this.state.phone}
                    onChange={(e)=>this.setState({phone: e.target.value})}
                    validations={[required, phoneV]} 
                    placeholder= "Enter phone number."
                />
                <label>CNIC</label>
                <VInput 
                    type="text"
                    name="cnic"
                    value={this.state.cnic}
                    onChange={(e)=>this.setState({cnic: e.target.value})}
                    validations={[required, cnicV]} 
                    placeholder= "Enter last 6 digits of cnic."
                />
                <VButton>Proceed</VButton>
            </VForm>
            {this.state.error &&
                <div className="jazzcash_error">
                    {this.state.error_message}
                </div>
            }
        </div>
    )
    renderStep2 = () => (
        <div className="jazzcash_content count_down_container text-center">
            {this.state.count_down &&
                <>
                    <Countdown360
                        seconds={this.state.re_inquire_times == 2 ? 10 : 40}
                        borderFillColor="#E8E7E7"
                        borderUnfillColor="#FECA13"
                        borderWidth="3"
                        fontSize="30"
                        fontWeight="normal"
                        clockwise
                        width="158"
                        smooth
                        onComplete={()=>this.handleInquiryRequest()}
                    />
                    <h3>Authorization required.</h3>
                    <p>Please approve this transaction in your JazzCash app to proceed.</p>
                </>
            }
            {this.state.error &&
                <div className="jazzcash_error">
                    {this.state.error_message}
                </div>
            }
        </div>
    )

    render() {
        return (
            <div className="page_container">
                <div className="jazzcash_container">
                    {this.state.step == 1 && <span onClick={()=>this.handleReturnBack()}>X <span>Cancel</span></span>}
                    <div className="jazzcash_header">
                        <img src={jazzCashLogo} />
                    </div>
                    {this.state.waiting ?
                        <Waiting height='400px' />
                    :
                        this.state.step == 1 ?
                            this.renderStep1()
                        :this.state.step == 2 ?
                            this.renderStep2()
                        :
                            <JazzCashStatus 
                                jazzcash_status={this.state.jazzcash_status}
                                status_message={this.state.status_message}
                                redirection_url={this.state.redirection_url}
                            />
                            
                    }
                    <div className="jazzcash_footer">
                        <span>Powered by</span>
                        <img src={paymobLogo} className="paymob" alt="Paymob" />
                    </div>
                </div>
            </div>
        )
    }
}
export default JazzCash;